import { render, staticRenderFns } from "./freeback.vue?vue&type=template&id=ed3bfacc&scoped=true&"
import script from "./freeback.vue?vue&type=script&lang=js&"
export * from "./freeback.vue?vue&type=script&lang=js&"
import style0 from "./freeback.vue?vue&type=style&index=0&id=ed3bfacc&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed3bfacc",
  null
  
)

export default component.exports